import { useContext } from 'react';
import CheckoutContext from '../context/CheckoutContext';

const useCheckoutContext = () => {
  return useContext(CheckoutContext);
};

export default useCheckoutContext;
